<template>
    <el-drawer
        title="赠票发放统计"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <div v-if="dataMessage" class="message MT20">
                <el-alert type="error" :closable="false" center>
                    <div slot="title">{{dataMessage}}</div>
                </el-alert>
                <el-button icon="el-icon-refresh" @click="getData" size="small" class="MT20">重新获取</el-button>
            </div>
            <div v-if="data">
                <el-alert type="warning" :closable="false" center>
                    <div slot="title">场地允许赠票数上限: {{data.maxNum}}条</div>
                </el-alert>
                <el-table
                    :data="data.ticketPriceDataList"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                    class="MT20"
                >
                    <el-table-column prop="ticketPriceName" label="票品名称"></el-table-column>
                    <el-table-column prop="hasSendNum" label="已送数量"></el-table-column>
                    <el-table-column prop="canSendNum" label="可送数量"></el-table-column>
                </el-table>
                <el-table
                    :data="data.sessionDataList"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                    class="MT20"
                >
                    <el-table-column prop="key" label="场次"></el-table-column>
                    <el-table-column prop="num" label="已发放有效数量"></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="drawer-footer">
            <!-- <el-button @click="close">取消</el-button> -->
            <el-button type="primary" @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props:{
        activityId: {
            type: [Number, String],
            default: () => null
        }
    },
    data(){
        return{
            drawerShow:false,
            data:null,
            dataMessage:'',
            dataLoading: false
        }
    },
    mounted(){
        // this.getData();
    },
    methods:{
        show(){
            this.getData();
            this.drawerShow = true
        },
        close(){
            this.drawerShow = false
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/activity/presentStatistic',
                params: {activityId:this.activityId},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.dataMessage = "";
                    } else {
                        this.dataMessage =  msg || '获取数据失败';
                    }
                })
                .catch(() => {
                    this.dataMessage =  '获取数据失败';
                }).finally(() => {
                    this.dataLoading = false;
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.message{
    text-align: center;
}
</style>